// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 08.30.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// JS extensions and helpers for Bootstrap's Popover component
// -----------------------------------------------------------------------------

const Popover = (($) => {
  const Selector = {
    POPOVER: '[data-toggle="popover"]',
    POPOVER_BODY: '.popover',
    POPOVER_ANCHORS: '.popover a',
    POPOVER_PHONE_NUM: '.popover .PhoneNumber7682'
  }

  const Event = {
    SHOWN: 'shown.bs.popover',
    HIDDEN: 'hidden.bs.popover',
    CLICK: 'click.popoverdismiss',
    MOUSEDOWN: 'mousedown.popover',
    ANCHOR_CLICK: 'click.popoveranchor'
  }

  /* --------------------------------------------------------------------------
    Private
  -------------------------------------------------------------------------- */
  // Implementation recommended by Bootstrap here:
  // https://getbootstrap.com/docs/4.1/components/popovers/#dismiss-on-next-click
  function initDismissOnClick () {
    $('.popover-dismiss').popover({
      trigger: 'focus'
    })

    stopPropogationOfDismissClick()
  }

  function stopPropogationOfDismissClick () {
    $(Selector.POPOVER).on(Event.SHOWN, () => {
      // Prevent the dismiss click from triggering click event on other elements
      $('body').on(Event.CLICK, e => e.preventDefault())

      // Prevent click on popover-body from closing popover
      $(Selector.POPOVER_BODY).on(Event.MOUSEDOWN, e => e.preventDefault())

      // Allow any <a> tags within popover to be remain clickable
      $(Selector.POPOVER_ANCHORS).on(Event.ANCHOR_CLICK, e => e.stopPropagation())
    })

    // Teardown event handlers
    $(Selector.POPOVER).on(Event.HIDDEN, () => {
      $('body').off(Event.CLICK)
      $(Selector.POPOVER_BODY).off(Event.MOUSEDOWN)
      $(Selector.POPOVER_ANCHORS).off(Event.ANCHOR_CLICK)
    })
  }

  // Since popover content is instantiated after page load, any phone numbers within
  // the popover body will not get updated to the dynamic tracking number.
  function initTrackingPhoneUpdater () {
    if (window._ictt) {
      $(Selector.POPOVER).on(Event.SHOWN, () => {
        const dynamicNumbers = window._ictt.push(['_getAllocatedNumbers'])
        const number = dynamicNumbers['7682']

        if (number) {
          $(Selector.POPOVER_PHONE_NUM).text(number)
        }
      })
    }
  }

  /* --------------------------------------------------------------------------
    Public
  -------------------------------------------------------------------------- */

  const Popover = {
    init () {
      for (const popover of $(Selector.POPOVER)) {
        $(popover).popover({
          container: 'body'
        })
      }

      initDismissOnClick()
      initTrackingPhoneUpdater()
    }
  }

  return Popover
})(jQuery)

export default Popover
